/** H5 sessionStorage key，与小程序 cap_auth_token 语义一致 */
export const STORAGE_TOKEN_KEY = 'cap_auth_token'
